import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CustomParametersRealtimeView } from './custom-params-realtime-view';

export function CustomParameters({
  id, value, onChange, legacyI18n, permissions, forceUseIncreasedCount,
}) {
  let container;

  const onCustomParametersUpdated = useCallback(({
    isValid, customParameters: newCustomParameters,
  }) => {
    onChange({ isValid, value: newCustomParameters });
  }, [onChange]);

  useEffect(() => {
    const view = new CustomParametersRealtimeView({
      i18n: legacyI18n,
      customParameters: value,
      permissions,
      forceUseIncreasedCount,
    });
    view.on('change:customParameters', onCustomParametersUpdated);
    view.render().$el.appendTo(container);

    return () => {
      view.remove();
    };
    // We want the view to be created only once,
    // hence ignoring all dependencies of this "effect".
    // This means that view will ignore changes to all props.
    // If need be to make view pick props updates, the view
    // need to provide a way to communicate such update to it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id={id} ref={(ref) => { container = ref; }} />
  );
}

CustomParameters.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  legacyI18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  permissions: PropTypes.shape({}).isRequired,
  forceUseIncreasedCount: PropTypes.bool,
};

CustomParameters.defaultProps = {
  forceUseIncreasedCount: false,
};
